import React from 'react';
import { Form, FormGroup, FormControl, Button, Modal, Container, Row, Col, Spinner } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import moment from 'moment';
import { Navigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { apiFetch } from '../../_services/apiFetch';
import { canAccessPlanningModule, isPlanner } from '../../utils/roleConstants';

// Exact wording required by the TPM brief; the server sends the same string.
const TPM_BLOCK_MESSAGE = 'This part no cannot be used because it needs maintenance';
const PLANNING_DETAILS_TTL_MS = 5 * 60 * 1000;
import {
    Scheduler,
    SchedulerData,
    ViewType,
    CellUnit,
    DATE_FORMAT,
} from 'react-big-schedule';
import 'react-big-schedule/dist/css/style.css';
import DemoData from './DemoData';
import '../../Assets/style.css';
import { HexColorPicker } from "react-colorful";
import { Autocomplete, TextField } from '@mui/material';
import ReactToPrint from 'react-to-print';
import utils from '../../utils';
import DataTable from 'react-data-table-component';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';
import {
    calcCompleteTimeHours,
    calculateMaterialConsumptionKg,
    calcRemainingTimeHours,
    countPlanningWorkingHours,
    composePlanningStart,
    formatPlanningTime,
    formatPlanningEndDate,
    formatPlanningStartDate,
    isPlanningWorkingMoment,
    formatMaterialConsumptionKg,
    planningTimestampToPickerTime,
    productionHoursFromCompleteTime,
    getPlanningDeletionReason,
} from './planningSchedule';
import { sortPlanningEventsByMachineCategory } from './planningEventSort';
import PlanningCalendar from './PlanningCalendar.jsx';
import PlanningMachineAutocomplete from './PlanningMachineAutocomplete.jsx';
import { normalizePlanningManpower, getPlanningManpower, buildPlanningTitle } from './planningCalendar';
import { findPlanningOverlaps } from './planningOverlap';


let schedulerData;
// Teach Autosuggest how to calculate suggestions for any given input value.
const getSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(lang =>
        (lang.partNo || '').toLowerCase().slice(0, inputLength) === inputValue
    );
};

const getJobSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(lang =>
        (lang.jobNo || '').toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
};

const getToolingSuggestions = (value, list = []) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(item =>
        (item.toolingNo || '').toLowerCase().slice(0, inputLength) === inputValue
    );
};

const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
};

const generatePlanningJobNo = (start) => {
    const datePrefix = moment(start).format('YYYYMMDD');
    const randomNum = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');

    return `${datePrefix}${randomNum}`;
};

const generatePlanningJobNumbers = (start, includeMasterJobNo) => ({
    jobNo: generatePlanningJobNo(start),
    masterJobNo: includeMasterJobNo ? generatePlanningJobNo(start) : '',
});

const resources = [
    {
        id: '1',
        name: '',
    },
    {
        id: '2',
        name: 'Manpower',
        groupOnly: true,

    }
];

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
    <div>
        {suggestion.partNo}
    </div>
);

const renderJobSuggestion = suggestion => (
    <div>
        {suggestion.jobNo}
    </div>
);

const renderToolingSuggestion = suggestion => (
    <div>
        {suggestion.toolingNo}
    </div>
);

class Planning extends React.Component {
    _isMounted = false;
    _currentJobNo = ''; // Synchronously tracked jobNo to avoid async setState race conditions
    _planningRequest = null;
    _planningRequestKey = '';
    _planningRequestSeq = 0;
    _planningPollTimer = null;
    _planningJobDetails = new Map();
    _creatingJob = false;
    constructor(props) {
        super(props);
        schedulerData = new SchedulerData(new moment().format(DATE_FORMAT), ViewType.Custom1, false, false,
            {
                schedulerWidth: '80%',
                nonAgendaDayCellHeaderFormat: 'M/D|HH:mm',
                resourceName: '',
                //customResourceTableWidth: '0',
                customCellWidth: '18%',
                nonWorkingTimeHeadColor: '#888888',
                nonWorkingTimeHeadBgColor: '#e8e8e8',
                nonWorkingTimeBodyBgColor: '#f0f0f0',
                views: [
                    { viewName: 'Two weeks', viewType: ViewType.Custom1, showAgenda: false, isEventPerspective: false },
                ],
            }, {
            getCustomDateFunc: this.getCustomDate,
            isNonWorkingTimeFunc: this.isNonWorkingTime,
            getNonAgendaViewBodyCellBgColorFunc: this.getPlanningWeekendCellBgColor,
        });
        // schedulerData.localeMoment.locale('en');
        schedulerData.setResources(resources);
        this.state = {
            id: 0,
            completeTime: 0,
            remainingTime: 0,
            operationHours: 24,
            ot: false,
            otSaturday: false,
            list: [],
            jobnolist: [],
            products: [],
            toolings: [],
            machines: [],
            modalShow: false,
            newMode: true,
            newModalShow: false,
            body: [],
            boms: [],
            mouldLifeBalance: 0,
            machineNo: '',
            jobNo: '',
            masterJobNo: '',
            includeMasterJobNo: false,
            lineNo: '',
            actOutput: 0,
            jsQuantity: 0,
            machineTonnage: 0,
            mouldNo: '',
            mouldType: '',
            partWeight: 0,
            partNo: '',
            partDesc: '',
            partRunnerWeight: 0,
            pickingMode: false,
            cavityNo: 0,
            customer: '',
            po: '',
            cycleTime: 0,
            riskClass: 0,
            oee: 0,
            productivity: 0,
            executionNumber: 0,
            jobOrder: 0,
            total_output: 0,
            total_reject: 0,
            total_loss: 0,
            actOutput: 0,
            planOutput: 0,
            engReject: 0,
            prdReject: 0,
            machineDown: 0,
            mouldBreakdown: 0,
            jigFixture: 0,
            engineeringBuild: 0,
            machineSupportDoc: 0,
            manpower: 0,
            facility: 0,
            materialDelay: 0,
            unplanBriefing: 0,
            viewModel: schedulerData,
            allProcess: '',
            processes: [],
            process: 0,
            selectedMachine: 0,
            selectedDate: moment().format('YYYY-MM-DD'),
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD'),
            hasExplicitStartTime: false,
            displayColorPicker: false,
            suggestions: [],
            jobsuggestions: [],
            toolingSuggestions: [],
            remark: '',
            color: '#4A90E2',
            uoms: [],
            sources: [],
            categories: [],
            materialBatchNo: '',
            toolingCondition: -1,
            tpmBlocked: false,
            tpmBlockReason: '',
            loadingEvents: true,
            loadingEventDetails: false,
            planningEvents: [],
            planningError: '',
            planningRefreshing: false,
            creatingJob: false,
            overlappingJobs: [],
            overlapReason: '',
        }
        this.baseState = {
            ...this.state,
            loadingEvents: false,
            loadingEventDetails: false
        };
        this.loadData();

        //set locale moment to the schedulerData, if your locale isn't English. By default, Scheduler comes with English(en, United States).
        // moment.locale('zh-cn');
    }

    setLoadingEvents = (loadingEvents) => {
        if (this._isMounted) {
            this.setState({ loadingEvents });
        } else {
            this.state.loadingEvents = loadingEvents;
        }
    }

    loadData(d, options = {}) {
        const date = moment(d != null ? d : this.state.selectedDate).format('YYYY-MM-DD');
        const account = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        const accountId = account.accountId;
        if (!accountId) {
            this.setLoadingEvents(false);
            return Promise.resolve([]);
        }
        const requestKey = `${accountId}|${date}|${this.state.process}|${this.state.selectedMachine}`;
        const isPolling = options.poll === true;

        // Avoid duplicate requests when Show and the background poll land together.
        if (!options.force && this._planningRequest && this._planningRequestKey === requestKey) {
            return this._planningRequest;
        }

        this._planningRequestKey = requestKey;
        const requestSeq = ++this._planningRequestSeq;

        const hasCachedEvents = Array.isArray(this.state.planningEvents) && this.state.planningEvents.length > 0;
        if (options.silent && hasCachedEvents) {
            this.setState({ planningRefreshing: true, planningError: '' });
        } else {
            this.setLoadingEvents(true);
            this.setState({ planningRefreshing: false, planningError: '' });
        }

        const readJson = response => response.text().then(text => {
            const data = text ? JSON.parse(text) : null;
            const status = response && response.status;
            if (response && (response.ok === false || (status != null && (status < 200 || status >= 300)))) {
                throw new Error((data && data.error) || `Request failed with status ${status}`);
            }
            return data;
        });
        const masterPromise = isPolling
            ? Promise.resolve(Array.isArray(this.state.list) ? this.state.list : [])
            : fetch(`${config.apiUrl}/getMasterDataByCompany?company=${accountId}&ignore_limit=true`, requestOptions)
            .then(readJson)
            .then(body => {
                const list = body && Array.isArray(body.data) ? body.data : (Array.isArray(body) ? body : []);
                if (requestSeq === this._planningRequestSeq) this.setState({ list });
                return list;
            });

        if (!isPolling) {
            fetch(`${config.apiUrl}/getToolingByCompany?company=${accountId}&keyword=&limit=1000&offset=0`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(readJson)
                .then(body => {
                    const toolings = body && Array.isArray(body.data) ? body.data : (Array.isArray(body) ? body : []);
                    if (requestSeq === this._planningRequestSeq) this.setState({ toolings });
                })
                .catch(error => console.error('Error loading Planning tooling suggestions:', error));
        }

        if (accountId === 2 && !isPolling) {
            fetch(`${config.apiUrl}/getSoltemJobNoList`, requestOptions)
                .then(readJson)
                .then(body => {
                    if (requestSeq === this._planningRequestSeq) this.setState({ jobnolist: Array.isArray(body) ? body : [] });
                })
                .catch(error => console.error('Error loading Planning job suggestions:', error));
        }

        const machinesPromise = isPolling
            ? Promise.resolve(Array.isArray(this.state.machines) ? this.state.machines : [])
            : fetch(`${config.apiUrl}/getAllMachines?company=${accountId}`, requestOptions)
            .then(readJson)
            .then(data => Array.isArray(data) ? data : [])
            .catch(error => {
                console.error('Error loading machines for Planning sort:', error);
                return [];
            });

        const planningPromise = fetch(`${config.apiUrl}/getPlanning?company=${accountId}&start=${date}&end=${moment(date).add(13, 'days').format('YYYY-MM-DD')}&process=${this.state.process}&machine=${this.state.selectedMachine}`, requestOptions)
            .then(readJson)
            .then(data => Array.isArray(data) ? data : []);

        this._planningRequest = Promise.all([masterPromise, machinesPromise, planningPromise])
            .then(([masterList, machines, responseEvents]) => {
                if (requestSeq !== this._planningRequestSeq) return [];
                const masterById = new Map((masterList || []).map(master => [String(master.id), master]));
                const baseEvents = responseEvents
                    .filter(item => String(item.resourceId) !== '2')
                    .map((item, index) => {
                        const start = item.start;
                        const end = item.start === item.end
                            ? moment(item.end).format('YYYY-MM-DD 23:59:59')
                            : item.end;
                        return {
                            ...item,
                            id: item.id != null ? item.id : index,
                            oldId: item.oldId || item.id || index,
                            start,
                            end,
                            metricsPending: true,
                        };
                    });

                this.setState({
                    machines,
                    selectedDate: date,
                    // Stream raw rows on first load, but keep enriched jobs during
                    // revalidation: raw rows do not yet have machine/line assignments.
                    ...(!hasCachedEvents && { planningEvents: sortPlanningEventsByMachineCategory(baseEvents, machines) }),
                    loadingEvents: false,
                    planningRefreshing: true,
                });

                const uniqueJobIDs = [...new Set(baseEvents.filter(event => event.jobID).map(event => event.jobID))];
                const jobVersions = new Map();
                baseEvents.forEach(event => {
                    const key = `${accountId}|${event.jobID}`;
                    if (!jobVersions.has(key)) jobVersions.set(key, []);
                    jobVersions.get(key).push(event);
                });
                // Bound the cache to visible jobs and never share entries across accounts.
                this._planningJobDetails.forEach((_entry, key) => {
                    if (!jobVersions.has(key)) this._planningJobDetails.delete(key);
                });
                const totalRequests = new Map();
                const jobPromises = uniqueJobIDs.map(jobID => {
                    const key = `${accountId}|${jobID}`;
                    const version = JSON.stringify(jobVersions.get(key));
                    const cached = this._planningJobDetails.get(key);
                    // Show, Retry and successful mutations bypass cached details. A changed
                    // planning row or the five-minute TTL also invalidates a poll's entry.
                    const detailsPromise = isPolling && !options.force && cached
                        && cached.version === version && Date.now() - cached.loadedAt < PLANNING_DETAILS_TTL_MS
                        ? Promise.resolve(cached.value)
                        : Promise.all([
                            fetch(`${config.apiUrl}/getJobByFilter?id=${jobID}`, requestOptions).then(readJson),
                            fetch(`${config.apiUrl}/getJobsheet?jobID=${jobID}`, requestOptions).then(readJson),
                        ]).then(value => {
                            if (requestSeq === this._planningRequestSeq) {
                                this._planningJobDetails.set(key, { version, value, loadedAt: Date.now() });
                            }
                            return value;
                        });
                    return detailsPromise
                        .then(([jobResponse, jobsheetResponse]) => {
                            const job = Array.isArray(jobResponse) ? jobResponse[0] : jobResponse;
                            const jobsheetRows = jobsheetResponse && Array.isArray(jobsheetResponse.data)
                                ? jobsheetResponse.data
                                : jobsheetResponse;
                            const jobsheet = Array.isArray(jobsheetRows) ? jobsheetRows[0] : jobsheetRows;
                            const masterID = jobsheet && jobsheet.masterID != null ? jobsheet.masterID : (job && job.masterID);
                            const master = masterById.get(String(masterID));
                            const machineNo = jobsheet && jobsheet.machineNo ? jobsheet.machineNo : '';
                            const lineNo = jobsheet && jobsheet.lineNo ? jobsheet.lineNo : '';
                            const finish = details => ({
                                jobID,
                                manpower: getPlanningManpower(jobsheet),
                                ot: jobsheet?.ot === true,
                                otSaturday: jobsheet?.otSaturday === true,
                                machineNo,
                                lineNo,
                                partNo: (job && job.partNo) || (master && master.partNo) || '',
                                masterID,
                                operationHours: Number(jobsheet && jobsheet.operationHours) || Number(job && job.operationHours) || 24,
                                isClosed: details && details.isClosed === true,
                                cycleTime: Number(master && (master.cycleTime ?? master.cycle_time)) || 0,
                            });

                            if (job && job.partNo && job.jobNo) {
                                const totalUrl = `${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(job.partNo || '')}&jobNo=${encodeURIComponent(job.jobNo || '')}&company=${encodeURIComponent(accountId || '')}`;
                                // Production totals remain fresh every poll, with duplicate
                                // part/job pairs sharing one request within that refresh.
                                if (!totalRequests.has(totalUrl)) {
                                    totalRequests.set(totalUrl, fetch(totalUrl, requestOptions).then(readJson));
                                }
                                return totalRequests.get(totalUrl)
                                    .then(result => {
                                        const totalOutput = this.safeNumber(result && result[0] ? result[0].total_output : 0);
                                        const jsQuantity = this.safeNumber(job.jsQuantity);
                                        return finish({ isClosed: jsQuantity > 0 && jsQuantity <= totalOutput });
                                    });
                            }
                            return finish({ isClosed: false });
                        })
                        .catch(error => {
                            console.error(`Error fetching job ${jobID}:`, error);
                            return { jobID, isClosed: false, machineNo: '', lineNo: '', planOutput: 0 };
                        });
                });

                return Promise.all(jobPromises).then(jobStatuses => {
                    if (requestSeq !== this._planningRequestSeq) return [];
                    const detailsByJobID = new Map(jobStatuses.map(status => [status.jobID, status]));
                    const enrichedEvents = baseEvents.map(event => {
                        const details = detailsByJobID.get(event.jobID);
                        // Build the title from the current job sheet and Part No; keep the
                        // saved title only when the live Part No is not available.
                        const baseTitle = details && details.partNo
                            ? buildPlanningTitle(details)
                            : String(event.title || '');
                        const title = details && details.isClosed && !/\[CLOSED\]$/i.test(baseTitle)
                            ? `${baseTitle} [CLOSED]`
                            : baseTitle;
                        return {
                            ...event,
                            title,
                            manpower: details ? details.manpower : null,
                            ot: details?.ot === true,
                            otSaturday: details?.otSaturday === true,
                            machineNo: details ? details.machineNo : '',
                            lineNo: details ? details.lineNo : '',
                            masterID: details ? details.masterID : event.masterID,
                            operationHours: (details && details.operationHours) || event.operationHours || 24,
                            cycleTime: details ? details.cycleTime : 0,
                            metricsPending: false,
                        };
                    });

                    schedulerData.setDate(date);
                    schedulerData.setEvents(enrichedEvents);
                    this.setState({
                        viewModel: schedulerData,
                        planningEvents: sortPlanningEventsByMachineCategory(enrichedEvents, machines),
                        loadingEvents: false,
                        planningRefreshing: false,
                        planningError: '',
                    });
                    return enrichedEvents;
                });
            })
            .catch(error => {
                if (requestSeq !== this._planningRequestSeq) return [];
                console.error('Error loading planning events:', error);
                this.setState({
                    loadingEvents: false,
                    planningRefreshing: false,
                    planningError: 'Unable to load planning data.',
                });
                return [];
            })
            .finally(() => {
                if (requestSeq === this._planningRequestSeq) {
                    this._planningRequest = null;
                    this._planningRequestKey = '';
                }
            });

        return this._planningRequest;
    }
    componentDidMount() {
        this._isMounted = true;
        this._planningPollTimer = window.setInterval(() => {
            if (document.visibilityState === 'hidden') return;
            this.loadData(this.state.selectedDate, { silent: true, poll: true });
        }, 60000);
    }
    componentWillUnmount() {
        this._planningRequestSeq += 1;
        this._isMounted = false;
        if (this._planningPollTimer) {
            window.clearInterval(this._planningPollTimer);
            this._planningPollTimer = null;
        }
    }
    componentWillMount() {
        this._isMounted = false;

        if (localStorage.getItem('user') != null) {
            fetch(`${config.apiUrl}/getAllProcesses?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(process => {
                    // login successful if there's a user in the response
                    if (process) {
                        this.setState({ processes: process });
                    }
                });
        }

    }

    openNewJobForDate = (date, defaults = {}) => {
        const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
        if (!isPlanner(user)) {
            window.alert('Only planner id allowed to create planning.');
            return;
        }

        const selectedDate = moment(date).format('YYYY-MM-DD');
        const accountId = user.accountId;
        const autoJobNo = accountId !== 2 ? this.generateAutoJobNo(selectedDate) : '';
        const preserved = {
            list: this.state.list,
            jobnolist: this.state.jobnolist,
            toolings: this.state.toolings,
            machines: this.state.machines,
            planningEvents: this.state.planningEvents,
            selectedDate: this.state.selectedDate,
        };

        this.setState({
            ...this.baseState,
            ...preserved,
            modalShow: true,
            newMode: true,
            slotId: '1',
            start: defaults.start || `${selectedDate} 07:00:00`,
            end: defaults.start || `${selectedDate} 07:00:00`,
            machineNo: defaults.machineNo || '',
            lineNo: defaults.lineNo || '',
            jobNo: autoJobNo,
            masterJobNo: '',
            includeMasterJobNo: false,
            hasExplicitStartTime: Boolean(defaults.start),
        });
    };

    openNewJobForBoardSlot = (timestamp, assignment) => {
        this.openNewJobForDate(timestamp, { ...assignment, start: timestamp });
    };

    resizePlanningBoardEvent = (event, changes) => {
        // Board helpers already validate and preserve fractional working hours.
        this.persistPlanningChange(event, changes,
            `Do you want to resize the event? {eventTitle: ${event.title}, newStart: ${changes.start}, newEnd: ${changes.end}}`);
    };

    updatePlanningEventsOptimistically = (eventId, changes) => {
        const previous = this.state.planningEvents || [];
        const next = previous.map(event => {
            const currentId = event.oldId || event.id;
            return String(currentId) === String(eventId) ? { ...event, ...changes } : event;
        });
        this.setState({ planningEvents: next });
        return previous;
    };

    persistPlanningChange = (event, changes, message) => {
        const eventId = event && (event.oldId || event.id);
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }
        if (!window.confirm(message)) return;

        const previous = this.updatePlanningEventsOptimistically(eventId, changes);
        apiFetch(`${config.apiUrl}/updatePlanning`, {
            method: 'post',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...changes, id: eventId }),
        })
            .then(response => response.text().then(text => ({ response, data: text ? JSON.parse(text) : {} })))
            .then(({ response, data }) => {
                if (response.status !== 200 || (data && data.error)) {
                    throw new Error((data && data.error) || 'Unknown error');
                }
                this.loadData(this.state.selectedDate, { silent: true, force: true });
            })
            .catch(error => {
                console.error('Error updating planning:', error);
                this.setState({ planningEvents: previous });
                window.alert('Error updating planning: ' + error.message);
            });
    };

    movePlanningEvent = (event, changes) => {
        this.persistPlanningChange(
            event,
            changes,
            `Do you want to move the event? {eventTitle: ${event.title}, newStart: ${changes.start}, newEnd: ${changes.end}}`
        );
    };

    resizePlanningEvent = (event, changes) => {
        const normalizedChanges = this.normalizeDraggedSchedule(changes.start, changes.end, event.operationHours || 24, event.ot === true, event.otSaturday === true);
        this.persistPlanningChange(
            event,
            normalizedChanges,
            `Do you want to resize the event? {eventTitle: ${event.title}, newStart: ${normalizedChanges.start}, newEnd: ${normalizedChanges.end}}`
        );
    };

    removePlanningEvent = (event) => {
        const reason = getPlanningDeletionReason(event);
        if (reason) {
            window.alert(reason);
            return;
        }
        const eventId = event && (event.oldId || event.id);
        if (!eventId || !window.confirm(`Do you want to delete the event? {eventId: ${eventId}, eventTitle: ${event.title}}`)) {
            return;
        }
        const previous = this.state.planningEvents || [];
        this.setState({
            planningEvents: previous.filter(item => String(item.oldId || item.id) !== String(eventId)),
        });
        apiFetch(`${config.apiUrl}/deletePlanning?id=${eventId}`, requestOptions)
            .then(async response => {
                const text = await response.text();
                const body = text ? JSON.parse(text) : null;
                if (response.status !== 200 || body?.error || (Array.isArray(body) && body[0]?.error)) {
                    const error = new Error(body?.error || 'Unable to delete planning event.');
                    error.code = body?.code;
                    throw error;
                }
                this.loadData(this.state.selectedDate, { silent: true, force: true });
            })
            .catch(error => {
                console.error('Error deleting planning:', error);
                this.setState({ planningEvents: previous.map(item =>
                    error.code === 'JOB_HAS_PRODUCTION_DATA' && String(item.oldId || item.id) === String(eventId)
                        ? { ...item, hasProductionData: true } : item) });
                window.alert('Error deleting planning: ' + error.message);
            });
    };

    onChange = (event, { newValue }) => {
        this.setState({
            partNo: typeof newValue !== 'undefined' ? newValue : '',
        });
    };

    onJobNoChange = (event, { newValue }) => {
        this.setState({
            jobNo: typeof newValue !== 'undefined' ? newValue : '',

        });
    };

    onToolingNoChange = (event, { newValue }) => {
        this.setState({
            mouldNo: typeof newValue !== 'undefined' ? newValue : '',
        });
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // You already implemented this logic above, so just use it.
    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: getSuggestions(value, this.state.list)
        });
    };

    onJobSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            jobsuggestions: getJobSuggestions(value, this.state.jobnolist)
        });
    };

    onToolingSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            toolingSuggestions: getToolingSuggestions(value, this.state.toolings)
        });
    };

    // Autosuggest will call this function every time you need to clear suggestions.
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    onJobSuggestionsClearRequested = () => {
        this.setState({
            jobsuggestions: []
        });
    };

    onToolingSuggestionsClearRequested = () => {
        this.setState({
            toolingSuggestions: []
        });
    };


    // When suggestion is clicked, Autosuggest needs to populate the input
    // based on the clicked suggestion. Teach Autosuggest how to calculate the
    // input value for every given suggestion.
    getSuggestionValue = (suggestion) => {
        // Use _currentJobNo which is updated synchronously, avoiding async setState race conditions
        const jobNo = this._currentJobNo || this.state.jobNo;

        fetch(`${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(suggestion.partNo || '')}&jobNo=${encodeURIComponent(jobNo || '')}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(result => {
                this.getBom(suggestion.id);
                const currentTotal = result && result[0] ? result[0] : {};
                const totalOutput = this.safeNumber(currentTotal.total_output);
                this.fetchAndApplyToolingData({ partNo: suggestion.partNo }, totalOutput);

                if (currentTotal.total_output != null) {
                    const synced = this.syncDerivedScheduleFields({
                        total_output: currentTotal.total_output,
                        cycleTime: this.state.cycleTime,
                        jsQuantity: this.state.jsQuantity,
                    });
                    this.setState({
                        total_output: currentTotal.total_output,
                        total_reject: currentTotal.total_reject,
                        total_loss: currentTotal.total_loss,
                        remainingTime: synced.remainingTime,
                        completeTime: synced.completeTime,
                        end: synced.end,
                    });
                }
            });

        this.setState({
            ...suggestion,
            cavityNo: 0,
            mouldLifeBalance: 0
        });
        const synced = this.syncDerivedScheduleFields({
            cycleTime: suggestion.cycleTime,
            jsQuantity: this.state.jsQuantity,
        });
        this.setState({
            id: 0,
            cycleTime: suggestion.cycleTime,
            completeTime: synced.completeTime,
            remainingTime: synced.remainingTime,
            end: synced.end,
            start: synced.start,
            masterID: suggestion.id,
            allProcess: concatProcesses(suggestion)
        });

        return suggestion.partNo

        function concatProcesses(suggestion) {
            // Check new format: process column (comma-separated string)
            if (suggestion.process && suggestion.process.trim() !== '') {
                return suggestion.process;
            }

            // Fallback to legacy format: process1-5
            let i = 1,
                processes = '';

            do {
                if (suggestion[`process${i}`] !== '') {
                    processes += suggestion[`process${i}`] + ', ';
                }
                i++;
            } while (suggestion[`process${i}`] !== undefined);
            // remove the last comma
            processes = processes.slice(0, -2);

            return processes;
        }
    };

    getToolingSuggestionValue = (suggestion) => {
        this.fetchAndApplyToolingData(suggestion, this.state.total_output);

        return suggestion.toolingNo || '';
    };

    safeNumber = (value, fallback = 0) => {
        if (value === null || value === undefined || value === '') return fallback;
        const numberValue = Number(value);
        return isNaN(numberValue) ? fallback : numberValue;
    };

    calcCompleteTime = (jsQuantity, cycleTime, operationHours) =>
        calcCompleteTimeHours(jsQuantity, cycleTime, operationHours ?? this.state.operationHours);

    calcEndDate = (start, completeTimeHours, operationHours, preserveStartTime = false, ot = this.state.ot === true, otSaturday = this.state.otSaturday === true) => {
        const opHrs = operationHours ?? this.state.operationHours ?? 24;
        // Complete Time is scaled by 24/opHrs; End packs machine hours into daily shifts.
        const productionHours = productionHoursFromCompleteTime(completeTimeHours, opHrs);
        return formatPlanningEndDate(start, productionHours, true, opHrs, preserveStartTime, ot, otSaturday);
    };

    calcStartDate = (start) =>
        formatPlanningStartDate(start, true, this.state.operationHours || 24, this.state.ot === true, this.state.otSaturday === true);

    calcRemainingTime = (jsQuantity, totalOutput, cycleTime, operationHours) =>
        calcRemainingTimeHours(jsQuantity, totalOutput, cycleTime, operationHours ?? this.state.operationHours);

    /**
     * Keep Complete / Remaining / End in sync when schedule or qty-related fields change.
     * - Default: derive Complete/Remaining from qty/cycle/opHrs, then End from Start + Complete.
     * - fromEnd: derive Complete from working hours between Start–End, Remaining scales with output.
     */
    syncDerivedScheduleFields = (overrides = {}) => {
        const ot = overrides.ot !== undefined ? overrides.ot === true : this.state.ot === true;
        const otSaturday = overrides.otSaturday !== undefined ? overrides.otSaturday === true : this.state.otSaturday === true;
        const jsQuantity = overrides.jsQuantity !== undefined ? overrides.jsQuantity : this.state.jsQuantity;
        const total_output = overrides.total_output !== undefined ? overrides.total_output : this.state.total_output;
        const cycleTime = overrides.cycleTime !== undefined ? overrides.cycleTime : this.state.cycleTime;
        const operationHours = Number(
            overrides.operationHours !== undefined ? overrides.operationHours : this.state.operationHours
        ) || 24;
        const fromEnd = overrides.fromEnd === true;
        // Explicit Start times stay unchanged; date-only schedules use the normal work start.
        const preserveStartTime = overrides.preserveStartTime === true
            || (overrides.preserveStartTime === undefined && this.state.hasExplicitStartTime);

        let start = overrides.start !== undefined ? overrides.start : this.state.start;
        start = preserveStartTime
            ? moment(start).format('YYYY-MM-DD HH:mm:ss')
            : formatPlanningStartDate(start, true, operationHours, ot, otSaturday);

        let end;
        let completeTime;
        let remainingTime;

        if (fromEnd) {
            end = overrides.end !== undefined ? overrides.end : this.state.end;
            const productionHours = countPlanningWorkingHours(start, end, operationHours, false, ot, otSaturday);
            completeTime = productionHours * (24 / operationHours) || 1;
            const qty = Number(jsQuantity) || 0;
            const output = Number(total_output) || 0;
            if (qty > 0) {
                remainingTime = completeTime * Math.max(0, qty - output) / qty;
            } else {
                remainingTime = completeTime;
            }
        } else {
            completeTime = this.calcCompleteTime(jsQuantity, cycleTime, operationHours) || 1;
            remainingTime = this.calcRemainingTime(jsQuantity, total_output, cycleTime, operationHours);
            end = this.calcEndDate(start, completeTime, operationHours, preserveStartTime, ot, otSaturday);
        }

        return {
            start,
            end,
            completeTime,
            remainingTime,
            operationHours,
            ot,
            otSaturday,
        };
    };

    resetScheduleFromEndDate = (endDate) => {
        // Keep a chosen Start time when only the End date is edited.
        const operationHours = this.state.operationHours || 24;
        const currentTime = this.state.hasExplicitStartTime
            ? planningTimestampToPickerTime(this.state.start)
            : null;
        const startValue = currentTime
            ? composePlanningStart(moment(this.state.start).format('YYYY-MM-DD'), currentTime, operationHours)
            : formatPlanningStartDate(
                `${moment(this.state.start).format('YYYY-MM-DD')} 07:00:00`,
                true,
                operationHours,
                this.state.ot === true,
                this.state.otSaturday === true
            );
        const synced = this.syncDerivedScheduleFields({
            start: startValue,
            end: `${endDate} 23:59:59`,
            fromEnd: true,
            preserveStartTime: Boolean(currentTime),
            operationHours,
        });

        this.setState({ ...synced, hasExplicitStartTime: Boolean(currentTime) });
    };

    normalizeDraggedSchedule = (start, end, operationHours = this.state.operationHours || 24, ot = this.state.ot === true, otSaturday = this.state.otSaturday === true) => {
        const opHrs = operationHours;
        const normalizedStart = formatPlanningStartDate(start, true, opHrs, ot, otSaturday);
        // Drag span is already machine/shift hours (not 24/opHrs scaled).
        const dragHours = countPlanningWorkingHours(normalizedStart, end, opHrs, true, ot, otSaturday);
        const normalizedEnd = formatPlanningEndDate(normalizedStart, dragHours, true, opHrs, false, ot, otSaturday);
        return { start: normalizedStart, end: normalizedEnd };
    };

    normalizeToolingResponse = (body) => {
        if (!body) return null;
        if (Array.isArray(body)) return body[0] || null;
        if (body.data && Array.isArray(body.data)) return body.data[0] || null;
        return body.data || body;
    };

    findToolingByNo = (toolingNo) => {
        const value = String(toolingNo || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.toolingNo || '').trim() === value) || null;
    };

    findToolingByPartNo = (partNo) => {
        const value = String(partNo || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.partNo || '').trim() === value) || null;
    };

    findToolingById = (toolingId) => {
        const value = String(toolingId || '').trim();
        if (!value) return null;
        return (this.state.toolings || []).find(item => String(item.id || '').trim() === value) || null;
    };

    getToolingQuery = (toolingSource) => {
        const tooling = typeof toolingSource === 'string'
            ? (this.findToolingByNo(toolingSource) || this.findToolingById(toolingSource) || { toolingNo: toolingSource })
            : toolingSource;

        if (!tooling) return '';
        if (tooling.id) return `id=${encodeURIComponent(tooling.id)}`;
        if (tooling.partNo) {
            const matchedTooling = this.findToolingByPartNo(tooling.partNo);
            if (matchedTooling && matchedTooling.id) return `id=${encodeURIComponent(matchedTooling.id)}`;

            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
            const companyQuery = user && user.accountId ? `&company=${encodeURIComponent(user.accountId)}` : '';
            return `partNo=${encodeURIComponent(tooling.partNo)}${companyQuery}`;
        }
        if (tooling.toolingNo) return `toolingNo=${encodeURIComponent(tooling.toolingNo)}`;
        return '';
    };

    fetchAndApplyToolingData = (toolingSource, totalOutput = 0) => {
        const query = this.getToolingQuery(toolingSource);
        if (!query) return Promise.resolve(null);

        return fetch(`${config.apiUrl}/getOneTooling?${query}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(body => {
                const tooling = this.normalizeToolingResponse(body);
                if (!tooling) return null;

                const toolingLife = this.safeNumber(tooling.toolingLife);
                const noCavity = this.safeNumber(tooling.noCavity, 1) || 1;
                const toolingCondition = this.safeNumber(tooling.toolingCondition);
                const machineTonnage = this.safeNumber(tooling.machineTonnage);

                this.setState({
                    mouldNo: tooling.toolingNo || this.state.mouldNo,
                    mouldType: tooling.toolingSystem || '',
                    cavityNo: noCavity,
                    toolingCondition,
                    machineTonnage,
                    mouldLifeBalance: Math.round(toolingLife - (this.safeNumber(totalOutput) / noCavity))
                });

                this.fetchTpmBlockState(tooling);

                return tooling;
            })
            .catch(err => {
                console.error('Error fetching tooling data:', err);
                return null;
            });
    };

    /**
     * A tooling with an Opened TPM maintenance cannot be scheduled. This drives
     * the inline warning and the save block; the server enforces the same rule
     * on the jobsheet/planning writes, so a stale tab cannot slip past it.
     */
    _tpmBlockRequestSeq = 0;
    fetchTpmBlockState = (tooling) => {
        const toolingId = tooling && tooling.id;
        const toolingNo = tooling && tooling.toolingNo;
        // Switching toolings quickly can land an earlier response after a later
        // one; only the newest request may write state.
        const requestId = ++this._tpmBlockRequestSeq;
        const isCurrent = () => requestId === this._tpmBlockRequestSeq;

        if (!toolingId && !toolingNo) {
            this.setState({ tpmBlocked: false, tpmBlockReason: '' });
            return Promise.resolve(null);
        }

        const query = toolingId
            ? `toolingId=${encodeURIComponent(toolingId)}`
            : `toolingNo=${encodeURIComponent(toolingNo)}`;

        return apiFetch(`${config.apiUrl}/getOpenTpmByTooling?${query}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.text().then(text => (text ? JSON.parse(text) : {})))
            .then(body => {
                if (!isCurrent()) return body;
                const blocked = !!(body && body.blocked);
                this.setState({
                    tpmBlocked: blocked,
                    tpmBlockReason: blocked ? (body.message || TPM_BLOCK_MESSAGE) : ''
                });
                return body;
            })
            .catch(err => {
                console.error('Error checking TPM maintenance status:', err);
                if (!isCurrent()) return null;
                // The server guard fails closed, so a failed check here only
                // costs the inline warning — the write is still rejected.
                this.setState({ tpmBlocked: false, tpmBlockReason: '' });
                return null;
            });
    };

    isBlockedByTpm = () => {
        if (!this.state.tpmBlocked) return false;
        window.alert(this.state.tpmBlockReason || TPM_BLOCK_MESSAGE);
        return true;
    };

    // Debounced fetch for Master Job No - loads Part No and related info
    _masterJobNoDebounceTimer = null;
    fetchMasterJobNoData = (masterJobNoValue) => {
        if (this._masterJobNoDebounceTimer) {
            clearTimeout(this._masterJobNoDebounceTimer);
        }
        this._masterJobNoDebounceTimer = setTimeout(() => {
            if (!masterJobNoValue || masterJobNoValue.trim() === '') return;
            fetch(`${config.apiUrl}/getMasterDataByMasterJobNo?masterJobNo=${encodeURIComponent(masterJobNoValue)}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(results => {
                    const data = Array.isArray(results) ? results[0] : results;
                    if (data && data.master) {
                        const master = data.master;
                        const allProcess = master.process || '';
                        const jsQuantity = data.jsQuantity || this.state.jsQuantity;
                        const synced = this.syncDerivedScheduleFields({
                            cycleTime: master.cycleTime || 0,
                            jsQuantity,
                            total_output: data.total_output || 0,
                        });
                        this.setState({
                            partNo: master.partNo || '',
                            partDesc: master.partDesc || '',
                            partWeight: master.partWeight || '',
                            partRunnerWeight: master.partRunnerWeight || '',
                            cycleTime: master.cycleTime || 0,
                            customer: master.customer || '',
                            riskClass: master.riskClass || 'select',
                            allProcess: allProcess,
                            masterID: master.id,
                            completeTime: synced.completeTime,
                            remainingTime: synced.remainingTime,
                            end: synced.end,
                            start: synced.start,
                            jsQuantity,
                            manpower: this.safeNumber(data.manpower, this.safeNumber(this.state.manpower, 0)),
                            po: data.po || this.state.po,
                            machineNo: data.machineNo || this.state.machineNo,
                            lineNo: data.lineNo || this.state.lineNo,
                            remark: data.remark || this.state.remark,
                            total_output: data.total_output || 0,
                            total_reject: data.total_reject || 0,
                            total_loss: data.total_loss || 0,
                            materialBatchNo: data.materialBatchNo || this.state.materialBatchNo,
                        }, () => {
                            this.fetchAndApplyToolingData(master.mouldNo, data.total_output || 0);
                        });
                        this.getBom(master.id);
                    }
                })
                .catch(err => {
                    console.error('Error fetching master data by Master Job No:', err);
                });
        }, 500);
    };

    getBom(masterID) {
        fetch(`${config.apiUrl}/getBomList?master_data_id=${masterID}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const ret = text && JSON.parse(text);
                    return ret.data ? ret.data : [];
                });
            })
            .then(data => {
                fetch(`${config.apiUrl}/getAllMaterialUom`, requestOptions)
                    .then((response) => {
                        return response.text().then(text => {
                            const data = text && JSON.parse(text);

                            return data;
                        });
                    })
                    .then(uom => {
                        // login successful if there's a user in the response
                        if (uom) {
                            this.setState({ uoms: uom });
                        }
                        fetch(`${config.apiUrl}/getAllMaterialSource`, requestOptions)
                            .then((response) => {
                                return response.text().then(text => {
                                    const data = text && JSON.parse(text);

                                    return data;
                                });
                            })
                            .then(source => {
                                // login successful if there's a user in the response
                                if (source) {
                                    this.setState({ sources: source });
                                }
                                fetch(`${config.apiUrl}/getAllMaterialCategory`, requestOptions)
                                    .then((response) => {
                                        return response.text().then(text => {
                                            const data = text && JSON.parse(text);

                                            return data;
                                        });
                                    })
                                    .then(category => {
                                        // login successful if there's a user in the response
                                        if (category) {
                                            this.setState({ categories: category });
                                            data.map((obj, i) => {
                                                obj.no = (i + 1);
                                                obj.total = (obj.usage * obj.per * this.state.jsQuantity).toFixed(2);
                                                obj.category = utils.mapTo(this.state.categories, obj.category);
                                                obj.uom = utils.mapTo(this.state.uoms, obj.uom);
                                                obj.source = utils.mapTo(this.state.sources, obj.source);
                                            });
                                            this.setState({ boms: data });
                                        }
                                    });
                            });

                    });
            });

    }

    getPartNoValue = (jobsuggestion, shouldFetchPartNo = false) => {
        // Early return if this is just for display (getOptionLabel calls)
        if (!shouldFetchPartNo) {
            // Just return the jobNo string for display purposes, don't do anything else
            // This prevents any side effects when called during rendering
            if (!jobsuggestion) return '';
            const jobNo = typeof jobsuggestion === 'string' ? jobsuggestion : (jobsuggestion.jobNo || '');
            return jobNo;
        }

        // Only proceed if shouldFetchPartNo is true (explicit user action)
        console.log('getPartNoValue called with shouldFetchPartNo=true for:', jobsuggestion?.jobNo);

        // Safety check: ensure we have a valid jobNo
        if (!jobsuggestion || !jobsuggestion.jobNo) {
            return jobsuggestion?.jobNo || '';
        }

        const accountId = JSON.parse(localStorage.getItem('user')).accountId;

        // Only call getPartNolistFromSolteam if accountId is 2 AND shouldFetchPartNo is true
        // shouldFetchPartNo should only be true when explicitly called from user action
        if (accountId === 2 && jobsuggestion.jobNo) {
            // Only make API call if jobNo is exactly 15 characters
            if (jobsuggestion.jobNo.length === 15) {
                fetch(`${config.apiUrl}/getPartNolistFromSolteam?jobNo=${jobsuggestion.jobNo}`, requestOptions)
                    .then((response) => {
                        return response.text().then(text => {
                            const data = text && JSON.parse(text);
                            return data;
                        });
                    })
                    .then(result => {
                        console.log('getPartNoValue API response:', result);
                        // Set partNo if it exists in the result, regardless of total_output
                        if (result && Array.isArray(result) && result.length > 0 && result[0].partNo) {
                            console.log('Setting partNo to:', result[0].partNo);
                            this.setState({
                                partNo: result[0].partNo,
                            });
                        } else if (result && result.partNo) {
                            // Handle case where result is an object, not an array
                            console.log('Setting partNo to:', result.partNo);
                            this.setState({
                                partNo: result.partNo,
                            });
                        } else {
                            console.log('No partNo found in result:', result);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching part number:', error);
                    });
            }
        }

        // Update state with the job suggestion
        this.setState(jobsuggestion);
        return jobsuggestion.jobNo
    };

    // Generate auto jobNo based on year + month + day + 6 digits random number
    generateAutoJobNo = (start = this.state.start) => {
        return generatePlanningJobNo(start);
    };

    onClickProductSelected(cell, row, rowIndex) {
        // Find the record in body by matching id
        const record = this.state.body.find(r => r.id === row.id) || (row.id ? row : null);
        if (!record) {
            return;
        }
        this.setState({ modalShow: true });
        this.setState({ newMode: false });
        this.setState({ timestamp: record.Timestamp });
        this.setState({ executionNumber: record.executionNumber });
        this.setState({ cycleTime: record.cycleTime });
        this.setState({ jobOrder: record.jobOrder });
        this.setState({ employeeID: record.employeeID });
        this.setState({ actOutput: record.actOutput });
        this.setState({ planOutput: record.planOutput });
        this.setState({ engReject: record.engReject });
        this.setState({ prdReject: record.prdReject });
        this.setState({ machineDown: record.machineDown });
        this.setState({ mouldBreakdown: record.mouldBreakdown });
        this.setState({ jigFixture: record.jigFixture });
        this.setState({ engineeringBuild: record.engineeringBuild });
        this.setState({ machineSupportDoc: record.machineSupportDoc });
        this.setState({ manpower: this.safeNumber(record.manpower, 0) });
        this.setState({ facility: record.facility });
        this.setState({ materialDelay: record.materialDelay });
        this.setState({ unplanBriefing: record.unplanBriefing });
        this.setState({ oee: record.oee });
        this.setState({ productivity: record.productivity });
        this.setState({ remark: record.remark });
        this.setState({ id: record.id });
    }

    onDeleteProduct(cell, row, rowIndex) {
        // Find the record in body by matching id, or use row.id directly
        const recordId = row && row.id ? row.id : (this.state.body && this.state.body[rowIndex] ? this.state.body[rowIndex].id : null);
        if (!recordId) {
            return;
        }
        fetch(`${config.apiUrl}/delete`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                id: recordId,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                }
            });
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        this.onClickProductSelected(cell, row, rowIndex)}
                >
                    Edit
                </button>
                <button
                    style={{ marginRight: 10 }}
                    type="button"
                    onClick={() =>
                        window.confirm("Are you sure you delete this data?") && this.onDeleteProduct(cell, row, rowIndex)}
                >
                    Delete
                </button>
            </div>
        )
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color })
    };

    render() {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!canAccessPlanningModule(user)) {
            return <Navigate to='/' />
        }

        const styles = {
            color: {
                width: '36px',
                height: '14px',
                borderRadius: '2px',
                backgroundColor: this.state.color,
            },
            swatch: {
                padding: '5px',
                background: '#fff',
                borderRadius: '1px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                display: 'inline-block',
                cursor: 'pointer',
            },
            popover: {
                position: 'absolute',
                zIndex: 10000,
                top: '100%',
                left: '0px',
                marginTop: '5px',
                backgroundColor: 'white',
                padding: '10px',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            },
            cover: {
                position: 'fixed',
                top: '0px',
                right: '0px',
                bottom: '0px',
                left: '0px',
                zIndex: 9999,
            },
            schedulerLoadingOverlay: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                minHeight: '320px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '10px',
                backgroundColor: 'rgba(255,255,255,0.78)',
                color: '#333',
                zIndex: 20,
                fontWeight: 600,
            },
            eventDetailsLoadingOverlay: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255,255,255,0.62)',
                zIndex: 1050,
            },
            eventDetailsLoadingBox: {
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 18px',
                borderRadius: '6px',
                backgroundColor: '#ffffff',
                boxShadow: '0 8px 24px rgba(0,0,0,0.16)',
                color: '#333',
                fontWeight: 600,
            },
        };
        let { suggestions, jobsuggestions, toolingSuggestions, slotId, color, slotName, allProcess, total_loss, total_output, total_reject, start, end, type, item, viewModel, id, jobNo, jsQuantity, partDesc, partRunnerWeight, partWeight, cavityNo, customer, po, riskClass, machineNo, lineNo, machineTonnage, mouldNo, mouldType, mouldLifeBalance, remainingTime, completeTime, modalShow, newMode, partNo, cycleTime, manpower, remark, selectedDate, loadingEvents, loadingEventDetails } = this.state;
        const totalMaterialConsumption = calculateMaterialConsumptionKg(jsQuantity, partWeight);
        const formattedMaterialConsumption = formatMaterialConsumptionKg(jsQuantity, partWeight);
        const inputPropsJob = {
            placeholder: 'Type job no.',
            value: jobNo,
            onChange: this.onJobNoChange
        };
        const inputProps = {
            placeholder: 'Type part no.',
            value: partNo,
            onChange: this.onChange
        };
        const renderJobNoField = () => {
            const accountId = JSON.parse(localStorage.getItem('user')).accountId;
            if (accountId === 2) {
                return <Autocomplete
                    freeSolo
                    size="small"
                    options={jobsuggestions}
                    filterOptions={(options) => options}
                    componentsProps={{
                        popper: {
                            style: { zIndex: 9999 }
                        }
                    }}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        return option.jobNo || '';
                    }}
                    isOptionEqualToValue={(option, value) => {
                        const optionJobNo = typeof option === 'string' ? option : option.jobNo;
                        const valueJobNo = typeof value === 'string' ? value : value.jobNo;
                        return optionJobNo === valueJobNo;
                    }}
                    onInputChange={(event, value, reason) => {
                        this._currentJobNo = value || '';
                        this.setState({ jobNo: value || '' });

                        if (value && value.length === 15 && accountId === 2 && reason === 'input') {
                            this.getPartNoValue({ jobNo: value }, true);
                        }

                        if (value) {
                            this.onJobSuggestionsFetchRequested({ value });
                        } else {
                            this.onJobSuggestionsClearRequested();
                        }
                    }}
                    onChange={(event, value, reason) => {
                        if (value && (reason === 'selectOption' || reason === 'createOption')) {
                            const jobNoValue = typeof value === 'string' ? value : (value.jobNo || '');
                            this._currentJobNo = jobNoValue;
                            this.setState({ jobNo: jobNoValue });

                            if (jobNoValue && accountId === 2) {
                                const jobSuggestion = typeof value === 'string' ? { jobNo: jobNoValue } : value;
                                this.getPartNoValue(jobSuggestion, true);
                            }
                        }
                    }}
                    renderOption={(props, option) => (
                        <li {...props}>
                            {renderJobSuggestion(option)}
                        </li>
                    )}
                    renderInput={(params) => {
                        const { onChange, ...restInputProps } = inputPropsJob;
                        return (
                            <TextField
                                {...params}
                                {...restInputProps}
                                size="small"
                                variant="outlined"
                            />
                        );
                    }}
                />;
            }

            return <input
                className="form-control"
                value={jobNo}
                onChange={(e) => {
                    this._currentJobNo = e.target.value;
                    this.setState({ jobNo: e.target.value });
                }}
                placeholder="Enter Job No"
            />;
        };
        const machineNames = [...new Set((this.state.machines || [])
            .filter(item => item.active !== false)
            .map(item => String(item.machine || '').trim())
            .filter(Boolean))].sort((left, right) => left.localeCompare(right));
        const partNoField = <Autocomplete
            freeSolo
            size="small"
            options={suggestions}
            filterOptions={(options) => options}
            value={partNo || null}
            componentsProps={{
                popper: {
                    style: { zIndex: 9999 }
                }
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.partNo || '';
            }}
            onInputChange={(event, value) => {
                this.setState({ partNo: value || '' });
                if (value) {
                    this.onSuggestionsFetchRequested({ value });
                } else {
                    this.onSuggestionsClearRequested();
                }
            }}
            onChange={(event, value) => {
                if (value) {
                    const partNoValue = typeof value === 'string' ? value : value.partNo;
                    this.getSuggestionValue(typeof value === 'string' ? { partNo: partNoValue } : value);
                }
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    {renderSuggestion(option)}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Type part no."
                    size="small"
                    variant="outlined"
                />
            )}
        />;
        const toolingNoField = <Autocomplete
            freeSolo
            size="small"
            options={toolingSuggestions}
            filterOptions={(options) => options}
            value={mouldNo || null}
            componentsProps={{
                popper: {
                    style: { zIndex: 9999 }
                }
            }}
            getOptionLabel={(option) => {
                if (typeof option === 'string') {
                    return option;
                }
                return option.toolingNo || '';
            }}
            isOptionEqualToValue={(option, value) => {
                const optionToolingNo = typeof option === 'string' ? option : option.toolingNo;
                const valueToolingNo = typeof value === 'string' ? value : value.toolingNo;
                return optionToolingNo === valueToolingNo;
            }}
            onInputChange={(event, value) => {
                this.setState({ mouldNo: value || '' });
                if (value) {
                    this.onToolingSuggestionsFetchRequested({ value });
                } else {
                    this.onToolingSuggestionsClearRequested();
                }
            }}
            onChange={(event, value) => {
                if (value && typeof value !== 'string') {
                    this.getToolingSuggestionValue(value);
                } else {
                    this.setState({ mouldNo: value || '' });
                }
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    {renderToolingSuggestion(option)}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Type tooling no."
                    size="small"
                    variant="outlined"
                />
            )}
        />;
        let handleClose = () => !this._creatingJob && this.setState({
            ...this.baseState,
            list: this.state.list,
            jobnolist: this.state.jobnolist,
            toolings: this.state.toolings,
            machines: this.state.machines,
            planningEvents: this.state.planningEvents,
            selectedDate: this.state.selectedDate,
            planningError: this.state.planningError,
            modalShow: false,
        });
        let handleSave = () => {
            if (this.isBlockedByTpm()) return;
            let { machineNo, lineNo, mouldLifeBalance, completeTime, jobNo, masterJobNo, includeMasterJobNo, remainingTime, company, total_loss, total_reject, total_output, partNo, jsQuantity, po, manpower, remark, masterID, start, end, color, slotId, jobID, operationHours, materialBatchNo, mouldNo } = this.state;
            manpower = normalizePlanningManpower(manpower);
            const selectedTooling = this.findToolingByNo(mouldNo);
            const toolingID = selectedTooling ? selectedTooling.id : null;
            window.confirm("Are you sure you update this data?") && apiFetch(`${config.apiUrl}/updateJobsheet`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    machineNo,
                    jobNo,
                    masterJobNo: includeMasterJobNo ? masterJobNo : '',
                    lineNo,
                    mouldLifeBalance,
                    jsQuantity,
                    totalMaterialConsumption,
                    po,
                    manpower,
                    remark,
                    completeTime,
                    remainingTime,
                    total_loss,
                    total_reject,
                    total_output,
                    masterID,
                    toolingID,
                    operationHours,
                    ot: this.state.ot === true,
                    otSaturday: this.state.otSaturday === true,
                    materialBatchNo,
                    id: jobID,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        apiFetch(`${config.apiUrl}/updatePlanning`, {
                            method: "post",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },

                            //make sure to serialize your JSON body
                            body: JSON.stringify({
                                start,
                                end,
                                resourceId: slotId,
                                bgColor: color.toUpperCase(),
                                title: buildPlanningTitle({ machineNo, lineNo, partNo, manpower }),
                                company: JSON.parse(localStorage.getItem('user')).accountId,
                                jobID
                            })
                        })
                            .then((response) => {
                                if (response.status == 200) {
                                    this.loadData();
                                    window.alert('Update Successfully.');
                                    this.setState({ modalShow: false });
                                }
                            });
                    } else {
                        // Surface a server-side rejection (e.g. the TPM guard
                        // when client state was stale) instead of failing silently.
                        response.text().then(text => {
                            let body = {};
                            try {
                                body = text ? JSON.parse(text) : {};
                            } catch (_error) {
                                body = {};
                            }
                            window.alert(body.error || 'Failed to update job sheet.');
                        });
                    }
                });
        }

        let createJob = (overlapReason = '') => {
            if (this.isBlockedByTpm()) return;
            let { machineNo, jobNo, masterJobNo, includeMasterJobNo, lineNo, mouldLifeBalance, completeTime, remainingTime, company, total_loss, total_reject, total_output, partNo, jsQuantity, po, manpower, remark, masterID, start, end, color, slotId, selectedDate, operationHours, materialBatchNo, mouldNo } = this.state;
            if (overlapReason) remark = `${overlapReason} - ${remark || ''}`;
            manpower = normalizePlanningManpower(manpower);
            const selectedTooling = this.findToolingByNo(mouldNo);
            const toolingID = selectedTooling ? selectedTooling.id : null;
            return apiFetch(`${config.apiUrl}/uploadJobsheet`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    machineNo,
                    jobNo,
                    masterJobNo: includeMasterJobNo ? masterJobNo : '',
                    lineNo,
                    mouldLifeBalance,
                    jsQuantity,
                    totalMaterialConsumption,
                    po,
                    manpower,
                    remark,
                    completeTime,
                    remainingTime,
                    total_loss,
                    total_reject,
                    total_output,
                    masterID,
                    toolingID,
                    operationHours,
                    ot: this.state.ot === true,
                    otSaturday: this.state.otSaturday === true,
                    materialBatchNo
                })
            })
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return { ok: response.ok, data };
                    });
                })
                .then(({ ok, data }) => {
                    // A rejection body (e.g. the TPM guard's 400/503) is still
                    // truthy JSON — only a created jobsheet carries an id, and
                    // /uploadPlanning must never run without one or it inserts
                    // an orphan planning row the guard cannot tie to a tooling.
                    if (!ok || !data || data.error || !data.id) {
                        window.alert((data && data.error) || 'Failed to create job sheet.');
                        return;
                    }
                    {
                        return apiFetch(`${config.apiUrl}/uploadPlanning`, {
                            method: "post",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },

                            //make sure to serialize your JSON body
                            body: JSON.stringify({
                                start,
                                end,
                                resourceId: slotId,
                                bgColor: color.toUpperCase(),
                                title: buildPlanningTitle({ machineNo, lineNo, partNo, manpower }),
                                company: JSON.parse(localStorage.getItem('user')).accountId,
                                jobID: data.id
                            })
                        })
                            .then((response) => {
                                if (response.status == 200) {
                                    this.setState({ modalShow: false, newMode: false, overlappingJobs: [], overlapReason: '' });
                                    this.loadData(this.state.selectedDate, { silent: true, force: true });
                                } else {
                                    throw new Error('Failed to create planning.');
                                }
                            });
                    }
                });
        }

        const handleCreate = async (reason = '') => {
            if (this._creatingJob || this.isBlockedByTpm()) return;
            if (this.state.overlappingJobs.length && !['FAMILY MOULD', 'COMBINED PROCESS'].includes(reason)) return;
            this._creatingJob = true;
            this.setState({ creatingJob: true });
            try {
                if (!reason && String(this.state.machineNo || '').trim()) {
                    const overlappingJobs = await findPlanningOverlaps({
                        company: JSON.parse(localStorage.getItem('user')).accountId,
                        machineNo: this.state.machineNo,
                        start: this.state.start,
                        end: this.state.end,
                    });
                    if (overlappingJobs.length) {
                        this.setState({ overlappingJobs, overlapReason: '' });
                        return;
                    }
                }
                await createJob(reason);
            } catch (error) {
                window.alert(error.message || 'Unable to create the job. Please try again.');
            } finally {
                this._creatingJob = false;
                this.setState({ creatingJob: false });
            }
        };
        const backToEdit = () => {
            if (!this._creatingJob) this.setState({ overlappingJobs: [], overlapReason: '' });
        };

        return (
            <main className="planning-overview">
                <PlanningCalendar
                    dateControls={
                        <Form>
                            <CustomDatePicker
                                label="Start Date"
                                controlId="formInlineDate"
                                value={this.state.selectedDate}
                                onChange={(value) => { this.setState({ selectedDate: value }); }}
                            />{' '}
                            <div className="planning-overview__load-actions">
                                <Button
                                    variant="primary"
                                    disabled={loadingEvents || this.state.planningRefreshing}
                                    onClick={() => this.loadData()}>Load</Button>
                                <span className="planning-overview__refresh" role="status" aria-live="polite" aria-atomic="true">
                                    {(loadingEvents || this.state.planningRefreshing) && <>
                                        <Spinner animation="border" size="sm" aria-hidden="true" />
                                        <span className="visually-hidden">{loadingEvents ? 'Loading planning data…' : 'Refreshing planning data…'}</span>
                                    </>}
                                </span>
                            </div>
                        </Form>
                    }
                    startDate={selectedDate}
                    events={this.state.planningEvents}
                    machines={this.state.machines}
                    canCreate={isPlanner(user)}
                    initialLoading={loadingEvents}
                    refreshing={this.state.planningRefreshing}
                    error={this.state.planningError}
                    onRetry={() => this.loadData()}
                    onAddJob={this.openNewJobForDate}
                    onAddBoardJob={this.openNewJobForBoardSlot}
                    onOpenJob={this.eventClicked}
                    onDeleteJob={this.removePlanningEvent}
                    onMoveJob={this.movePlanningEvent}
                    onResizeJob={this.resizePlanningEvent}
                    onResizeBoardJob={this.resizePlanningBoardEvent}
                />

                {loadingEventDetails && (
                    <div style={styles.eventDetailsLoadingOverlay}>
                        <div style={styles.eventDetailsLoadingBox}>
                            <DatacoLoadingIndicator loading={loadingEventDetails} size="compact" label="Loading event details" />
                        </div>
                    </div>
                )}

                <Modal show={modalShow && this.state.overlappingJobs.length > 0} onHide={backToEdit}>
                    <Modal.Header closeButton={!this.state.creatingJob}>
                        <Modal.Title>Overlapping job</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Another job is planned on machine {machineNo} during this time. Is this a family mould or a combined process?</p>
                        <fieldset disabled={this.state.creatingJob}>
                            <legend className="fs-6">Select a reason to continue</legend>
                            {['FAMILY MOULD', 'COMBINED PROCESS'].map(reason => (
                                <Form.Check key={reason} type="radio" name="planning-overlap-reason"
                                    id={`planning-overlap-${reason.replace(' ', '-').toLowerCase()}`}
                                    label={reason === 'FAMILY MOULD' ? 'Family mould' : 'Combined process'}
                                    checked={this.state.overlapReason === reason}
                                    onChange={() => this.setState({ overlapReason: reason })} />
                            ))}
                        </fieldset>
                        <p className="text-muted mt-3 mb-0">The selected reason will be added in UPPER CASE before your existing Remark.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" disabled={this.state.creatingJob} onClick={backToEdit}>Back to edit</Button>
                        <Button variant="primary" disabled={!this.state.overlapReason || this.state.creatingJob}
                            onClick={() => handleCreate(this.state.overlapReason)}>Continue anyway</Button>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName="modal-90w" show={modalShow && this.state.overlappingJobs.length === 0} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', gap: '20px' }}>
                                <div>
                                    {this.state.pickingMode == true ? 'Picking List' : (newMode ? 'New Job' : 'Edit Job')}
                                </div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    {this.state.pickingMode == false ? (
                                        <Button variant="secondary" onClick={e => this.setState({ pickingMode: true })}>Picking List</Button>
                                    ) : (
                                        <Button variant="secondary" onClick={e => this.setState({ pickingMode: false })}>Back</Button>
                                    )}
                                    <ReactToPrint
                                        trigger={() => <Button variant="secondary">Print</Button>}
                                        content={() => this.componentRef}
                                    />
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <fieldset disabled={this.state.creatingJob}>
                        {this.state.pickingMode == false ? <div>
                            <Form ref={el => (this.componentRef = el)} className="planning-job-form">
                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Schedule</div>
                                    <p className="text-muted small mb-2">
                                        Working week: Monday 7:00 to Saturday 7:00. Each OT checkbox adds its weekend shift from 7:00 using Operation Hours. Changing Start, End, OT, Operation Hours, JO Qty, Part, or actual output auto-updates Complete Time, Remaining Time, and End.
                                    </p>
                                    <Row>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Start</Form.Label>
                                            <input className="form-control" value={moment(start).format('YYYY-MM-DD')} type="date"
                                                onChange={(e) => {
                                                    const currentTime = this.state.hasExplicitStartTime
                                                        ? planningTimestampToPickerTime(this.state.start)
                                                        : null;
                                                    const nextStart = currentTime
                                                        ? composePlanningStart(e.target.value, currentTime, this.state.operationHours)
                                                        : `${e.target.value} 07:00:00`;
                                                    const synced = this.syncDerivedScheduleFields({
                                                        start: nextStart,
                                                        preserveStartTime: Boolean(currentTime),
                                                    });
                                                    const accountId = JSON.parse(localStorage.getItem('user')).accountId;
                                                    const jobNumbers = accountId !== 2
                                                        ? {
                                                            jobNo: generatePlanningJobNo(nextStart),
                                                            masterJobNo: this.state.includeMasterJobNo ? generatePlanningJobNo(nextStart) : '',
                                                        }
                                                        : {
                                                            jobNo: this.state.jobNo,
                                                            masterJobNo: this.state.masterJobNo,
                                                        };
                                                    this.setState({ ...synced, ...jobNumbers });
                                                }}
                                            />
                                            <Form.Label>Start time</Form.Label>
                                            <DatePicker
                                                selected={this.state.hasExplicitStartTime
                                                    ? planningTimestampToPickerTime(start)
                                                    : null}
                                                onChange={(time) => {
                                                    if (!time) return;
                                                    const selectedStart = composePlanningStart(
                                                        moment(start).format('YYYY-MM-DD'),
                                                        time,
                                                        this.state.operationHours
                                                    );
                                                    const synced = this.syncDerivedScheduleFields({
                                                        start: selectedStart,
                                                        preserveStartTime: true,
                                                    });
                                                    this.setState({ ...synced, hasExplicitStartTime: true });
                                                }}
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeCaption="Start time"
                                                dateFormat="h:mm aa"
                                                placeholderText="Select time"
                                                className="form-control"
                                                wrapperClassName="planning-time-picker-wrapper"
                                            />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>End</Form.Label>
                                            <input className="form-control" value={moment(end).format('YYYY-MM-DD')} type="date"
                                                onChange={(e) => {
                                                    this.resetScheduleFromEndDate(e.target.value);
                                                }}
                                            />
                                            <Form.Label>End time</Form.Label>
                                            <FormControl
                                                type="text"
                                                readOnly
                                                value={this.state.hasExplicitStartTime ? formatPlanningTime(end) : ''}
                                                placeholder="Calculated"
                                            />
                                        </Col>
                                        <Col md={2} sm={3} className="planning-form-field">
                                            <Form.Label>Operation Hours</Form.Label>
                                            <FormControl as="select" value={this.state.operationHours} onChange={(e) => {
                                                const synced = this.syncDerivedScheduleFields({
                                                    operationHours: Number(e.target.value),
                                                });
                                                this.setState(synced);
                                            }}>
                                                <option value={10}>10</option>
                                                <option value={12}>12</option>
                                                <option value={24}>24</option>
                                            </FormControl>
                                            <Form.Check id="planning-ot-saturday" type="checkbox" label="OT (Work on Saturday)" checked={this.state.otSaturday === true} style={{ marginTop: "20px" }}
                                                onChange={e => this.setState(this.syncDerivedScheduleFields({ otSaturday: e.target.checked }))} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Color</Form.Label>
                                            <div className="planning-color-control">
                                                <div style={styles.swatch} onClick={this.handleClick}>
                                                    <div style={styles.color} />
                                                </div>
                                                {this.state.displayColorPicker ? (
                                                    <>
                                                        <div style={styles.cover} onClick={this.handleClose} />
                                                        <div style={styles.popover} onClick={(e) => e.stopPropagation()}>
                                                            <HexColorPicker color={color} onChange={this.handleChange} />
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                            <Form.Check id="planning-ot" type="checkbox" label="OT (Work on Sunday)" checked={this.state.ot === true} style={{ marginTop: "20px" }}
                                                onChange={e => this.setState(this.syncDerivedScheduleFields({ ot: e.target.checked }))} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Job Details</div>
                                    <Row>
                                        <Col md={6} sm={12} className="planning-form-field">
                                            <Form.Label>Job No</Form.Label>
                                            {renderJobNoField()}
                                            <div style={{ marginTop: '10px' }}>
                                                <Form.Check
                                                    type="checkbox"
                                                    label="Include Master Job No"
                                                    checked={this.state.includeMasterJobNo}
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        const accountId = JSON.parse(localStorage.getItem('user')).accountId;
                                                        this.setState({
                                                            includeMasterJobNo: checked,
                                                            masterJobNo: checked && !this.state.masterJobNo ? (accountId !== 2 ? this.generateAutoJobNo() : '') : this.state.masterJobNo
                                                        });
                                                    }}
                                                />
                                            </div>
                                            {this.state.includeMasterJobNo && (
                                                <div style={{ marginTop: '10px' }}>
                                                    <Form.Label>Master Job No</Form.Label>
                                                    <input
                                                        className="form-control"
                                                        value={this.state.masterJobNo}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            this.setState({ masterJobNo: val });
                                                            this.fetchMasterJobNoData(val);
                                                        }}
                                                        placeholder="Enter or paste Master Job No"
                                                    />
                                                </div>
                                            )}
                                        </Col>
                                        <Col md={4} sm={12} className="planning-form-field">
                                            <Form.Label>Part No</Form.Label>
                                            {partNoField}
                                        </Col>
                                        <Col md={2} sm={12} className="planning-form-field">
                                            <Form.Label>JO Qty</Form.Label>
                                            <input className="form-control" type="number" onFocus={ev => ev.target.select()} onChange={ev => {
                                                const synced = this.syncDerivedScheduleFields({
                                                    jsQuantity: ev.target.value,
                                                });
                                                this.setState({
                                                    jsQuantity: ev.target.value,
                                                    ...synced,
                                                });
                                                this.getBom(this.state.masterID);
                                            }} value={jsQuantity} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Product And Customer</div>
                                    <Row>
                                        <Col md={12} className="planning-form-field">
                                            <Form.Label>Part Description</Form.Label>
                                            <input type="text" className="form-control" readOnly value={partDesc} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>No Cavity</Form.Label>
                                            <input type="number" className="form-control" readOnly value={cavityNo} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Part Weight</Form.Label>
                                            <input type="number" className="form-control" readOnly value={partWeight} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>P.R. Weight</Form.Label>
                                            <input type="number" className="form-control" readOnly value={partRunnerWeight} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Customer</Form.Label>
                                            <input type="text" className="form-control" readOnly value={customer} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Customer PO</Form.Label>
                                            <input type="text" className="form-control" onChange={ev => { this.setState({ po: ev.target.value }) }} value={po} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4} sm={12} className="planning-form-field">
                                            <Form.Label>Total Material Consumption</Form.Label>
                                            <input type="text" className="form-control" readOnly value={formattedMaterialConsumption} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Production Setup</div>
                                    <Row>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Process</Form.Label>
                                            <input type="text" className="form-control" readOnly value={allProcess} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label htmlFor="planning-job-machine">Machine</Form.Label>
                                            <PlanningMachineAutocomplete id="planning-job-machine" options={machineNames} value={machineNo} onChange={value => this.setState({ machineNo: value })} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label htmlFor="planning-job-line">Line</Form.Label>
                                            <PlanningMachineAutocomplete id="planning-job-line" options={machineNames} value={lineNo} onChange={value => this.setState({ lineNo: value })} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling No</Form.Label>
                                            {toolingNoField}
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling System</Form.Label>
                                            <input type="text" className="form-control" readOnly value={mouldType} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling Life Cycle</Form.Label>
                                            <input type="number" className="form-control" min="0" readOnly value={mouldLifeBalance} />
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Tooling Status</Form.Label>
                                            <input type="text" className="form-control" readOnly value={{ 0: 'OK', 1: 'NG', 2: 'Under Repair', 3: 'End of Life' }[this.state.toolingCondition] ?? '-'} />
                                            {this.state.tpmBlocked && (
                                                <div role="alert" style={{ color: '#dc3545', fontWeight: 600, marginTop: '4px', fontSize: '0.8125rem' }}>
                                                    {this.state.tpmBlockReason || TPM_BLOCK_MESSAGE}
                                                </div>
                                            )}
                                        </Col>
                                        <Col md={2} sm={6} className="planning-form-field">
                                            <Form.Label>Machine Tonnage</Form.Label>
                                            <input type="number" className="form-control" readOnly value={machineTonnage} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Material Batch No</Form.Label>
                                            <input type="text" className="form-control" onChange={ev => { this.setState({ materialBatchNo: ev.target.value }) }} value={this.state.materialBatchNo} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Progress And Risk</div>
                                    <Row>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Time required to complete by Operation Hours (Hrs)</Form.Label>
                                            <input className="form-control" type="number" readOnly value={(completeTime ?? 0).toFixed(2)} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Remaining Time (Hrs)</Form.Label>
                                            <input type="number" className="form-control" min="0" readOnly value={(remainingTime ?? 0).toFixed(2)} />
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Risk Class</Form.Label>
                                            <FormControl readOnly as="select" placeholder="select"
                                                value={riskClass} onChange={(e) => this.setState({ riskClass: e.target.value })}>
                                                <option value="select">select</option>
                                                <option key={1} value={1}>Low</option>
                                                <option key={2} value={2}>Medium</option>
                                                <option key={3} value={3}>High</option>
                                            </FormControl>
                                        </Col>
                                        <Col md={3} sm={6} className="planning-form-field">
                                            <Form.Label>Manpower</Form.Label>
                                            <input type="number" step="1" className="form-control" onFocus={ev => ev.target.select()} onChange={ev => { this.setState({ manpower: normalizePlanningManpower(ev.target.value) }) }} value={normalizePlanningManpower(manpower)} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Actual Cum Output</Form.Label>
                                            <input type="number" className="form-control" min="0" readOnly value={total_output} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Reject</Form.Label>
                                            <input type="number" className="form-control" min="0" readOnly value={total_reject} />
                                        </Col>
                                        <Col md={4} sm={6} className="planning-form-field">
                                            <Form.Label>Total Loss</Form.Label>
                                            <input type="number" className="form-control" min="0" readOnly value={total_loss} />
                                        </Col>
                                    </Row>
                                </section>

                                <section className="planning-form-section">
                                    <div className="planning-form-section-title">Notes</div>
                                    <Row>
                                        <Col md={12} className="planning-form-field">
                                            <Form.Label>Remark</Form.Label>
                                            <textarea className="form-control planning-remark-field" onChange={ev => { this.setState({ remark: ev.target.value }) }} value={remark} />
                                        </Col>
                                    </Row>
                                </section>
                            </Form>
                        </div> :
                            <div>
                                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                        <Col sm={1}><Form.Label>No</Form.Label></Col>
                                        <Col sm={1}><FormControl readOnly value={id} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>Customer</Form.Label></Col>
                                        <Col sm={5}><FormControl readOnly value={customer} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>Part No</Form.Label></Col>
                                        <Col sm={3}><FormControl readOnly value={partNo} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlinePlanOutput" style={{ marginBottom: '15px' }}>
                                        <Col sm={2}><Form.Label>Part Description</Form.Label></Col>
                                        <Col sm={7}><FormControl readOnly value={partDesc} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                        <Col sm={1}><Form.Label>JO Quantity</Form.Label></Col>
                                        <Col sm={2}><FormControl readOnly value={jsQuantity} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                    </FormGroup>
                                    <FormGroup className="row" as={Row} controlId="formInlineMaterialConsumption" style={{ marginBottom: '15px' }}>
                                        <Col sm={3}><Form.Label>Total Material Consumption</Form.Label></Col>
                                        <Col sm={9}><FormControl readOnly value={formattedMaterialConsumption} style={{ border: '2px solid #666', borderRadius: '4px', padding: '8px 12px', width: '100%', backgroundColor: '#f8f9fa', boxSizing: 'border-box', color: '#212529' }} /></Col>
                                    </FormGroup>

                                </div>
                                <div ref={el => (this.componentRef = el)}>
                                    <DataTable
                                        columns={[
                                            { name: 'No', selector: row => row.no, sortable: true, width: '5%' },
                                            { name: 'Material', selector: row => row.material, sortable: true, width: '10%' },
                                            { name: 'Material Description', selector: row => row.materialDesc, sortable: true, width: '15%' },
                                            { name: 'Color', selector: row => row.color, sortable: true, width: '10%' },
                                            { name: 'Code', selector: row => row.code, sortable: true, width: '5%' },
                                            { name: 'Usage', selector: row => row.usage, sortable: true, width: '5%' },
                                            { name: 'UoM', selector: row => row.uom, sortable: true, width: '5%' },
                                            { name: 'Per', selector: row => row.per, sortable: true, width: '5%' },
                                            { name: 'Where Use', selector: row => row.where_use, sortable: true, width: '10%' },
                                            { name: 'Source', selector: row => row.source, sortable: true, width: '10%' },
                                            { name: 'Category', selector: row => row.category, sortable: true, width: '10%' },
                                            { name: 'Supplier', selector: row => row.supplier, sortable: true, width: '10%' },
                                            { name: 'Total', selector: row => row.total, sortable: true, width: '10%' }
                                        ]}
                                        data={this.state.boms || []}
                                        highlightOnHover
                                        striped
                                    />
                                </div>
                            </div>}
                        </fieldset>
                    </Modal.Body>
                    {this.state.pickingMode == false ? <Modal.Footer>
                        <Button variant="secondary" disabled={this.state.creatingJob} onClick={handleClose}>
                            Cancel
                        </Button>
                        {this.state.creatingJob && <span role="status"><Spinner animation="border" size="sm" /> Checking and creating job…</span>}
                        {isPlanner(JSON.parse(localStorage.getItem('user'))) && newMode && (<Button variant="primary" disabled={this.state.creatingJob} onClick={() => handleCreate()}>
                            Create
                        </Button>)}
                        {/* only planner(role=3) can edit */}
                        {isPlanner(JSON.parse(localStorage.getItem('user'))) && !newMode && (<Button variant="primary" onClick={handleSave}>
                            Save Changes
                        </Button>)}
                    </Modal.Footer> : ''
                    }
                </Modal>
            </main>

        );

    }

    prevClick = (schedulerData) => {
        schedulerData.prev();
        this.setState({
            selectedDate: schedulerData.startDate
        })
        this.loadData(schedulerData.startDate);
    }

    nextClick = (schedulerData) => {
        schedulerData.next();
        this.setState({
            selectedDate: schedulerData.startDate
        })
        this.loadData(schedulerData.startDate);
    }

    onViewChange = (schedulerData, view) => {
        schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
        schedulerData.config.customCellWidth = view.viewType === ViewType.Custom ? 30 : 80;
        this.loadData(schedulerData.startDate);
    }

    onSelectDate = (schedulerData, date) => {
        schedulerData.setDate(moment(date).format('YYYY-MM-DD'));
        this.setState({
            selectedDate: moment(date).format('YYYY-MM-DD')
        })
        this.loadData(moment(date).format('YYYY-MM-DD'));
    }

    eventClicked = (schedulerDataOrEvent, selectedEvent) => {
        const event = selectedEvent || schedulerDataOrEvent;
        if (!event || !event.jobID) return;
        this.setState({ loadingEventDetails: true });
        fetch(`${config.apiUrl}/getJobsheet?jobID=${event.jobID}`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);

                    return data;
                });
            })
            .then(job => {
                if (job && Array.isArray(job.data)) job = job.data[0];
                job = Array.isArray(job) ? job[0] : job;
                if (job) {
                    job = Object.assign(job, { modalShow: true, newMode: false, id: event.id });
                    this.getBom(job.masterID);
                    return fetch(`${config.apiUrl}/getOneMasterData?id=${job.masterID}`, requestOptions)
                        .then((response) => {
                            return response.text().then(text => {
                                const data = text && JSON.parse(text);

                                return data;
                            });
                        })
                        .then(data => {
                            const jobManpower = normalizePlanningManpower(job.manpower);
                            const jobOt = job.ot === true;
                            const jobOtSaturday = job.otSaturday === true;
                            job = Object.assign(job, event);
                            job = Object.assign(job, data);
                            job = Object.assign(job, {
                                jobID: event.jobID,
                                manpower: jobManpower,
                                ot: jobOt,
                                otSaturday: jobOtSaturday,
                                masterID: job.masterID,
                                color: (event.bgColor || '#4A90E2').toUpperCase()
                            });

                            // Use local variables to avoid async setState race conditions
                            const opHrs = job.operationHours || 24;
                            const jsQuantity = job.jsQuantity || 0;
                            const cycleTime = data.cycleTime || 0;
                            const jobStart = job.start;
                            const newCompleteTime = this.calcCompleteTime(jsQuantity, cycleTime, opHrs);
                            const normalizedStart = moment(jobStart).format('YYYY-MM-DD HH:mm:ss');
                            const newEnd = this.calcEndDate(normalizedStart, newCompleteTime, opHrs, true, jobOt, jobOtSaturday);

                            // Single consolidated setState with all values
                            this.setState({
                                ...job,
                                start: normalizedStart,
                                operationHours: opHrs,
                                includeMasterJobNo: !!(job.masterJobNo && job.masterJobNo.length > 0),
                                completeTime: newCompleteTime,
                                remainingTime: this.calcRemainingTime(jsQuantity, job.total_output || 0, cycleTime, opHrs),
                                end: newEnd,
                                hasExplicitStartTime: true,
                                allProcess: data.process || '',
                                loadingEventDetails: false
                            }, () => {
                                this.fetchAndApplyToolingData(job.toolingID + '', job.total_output || 0);
                            });

                            // Fetch latest total qty to update remaining time with live data
                            if (job.jobNo && job.partNo) {
                                this._currentJobNo = job.jobNo;
                                fetch(`${config.apiUrl}/getCurrentTotalQty?partNo=${encodeURIComponent(job.partNo || '')}&jobNo=${encodeURIComponent(job.jobNo || '')}`, requestOptions)
                                    .then((response) => {
                                        return response.text().then(text => {
                                            const data = text && JSON.parse(text);
                                            return data;
                                        });
                                    })
                                    .then(result => {
                                        if (result && result[0] && result[0].total_output != null) {
                                            const synced = this.syncDerivedScheduleFields({
                                                jsQuantity,
                                                total_output: result[0].total_output,
                                                cycleTime,
                                                operationHours: opHrs,
                                                start: this.state.start,
                                            });
                                            this.setState({
                                                total_output: result[0].total_output,
                                                total_reject: result[0].total_reject,
                                                total_loss: result[0].total_loss,
                                                remainingTime: synced.remainingTime,
                                                completeTime: synced.completeTime,
                                                end: synced.end,
                                            }, () => {
                                                this.fetchAndApplyToolingData(job.toolingID + '', result[0].total_output);
                                            });
                                        }
                                    });
                            }
                        });
                }
                this.setState({ loadingEventDetails: false });
                return null;
            })
            .catch(error => {
                console.error('Error loading planning event details:', error);
                this.setState({ loadingEventDetails: false });
            });

    };

    ops1 = (schedulerData, event) => {
        alert(`You just executed ops1 to event: {id: ${event.id}, title: ${event.title}}`);
    };

    ops2 = (schedulerData, event) => {
        alert(`You just executed ops2 to event: {id: ${event.id}, title: ${event.title}}`);
    };

    newEvent = (schedulerData, slotId, slotName, start, end, type, item) => {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!isPlanner(user))
            return alert(`Only planner id allowed to create planning.`);

        // Generate auto jobNo if accountId is not 2
        const accountId = JSON.parse(localStorage.getItem('user')).accountId;
        const autoJobNo = accountId !== 2 ? this.generateAutoJobNo(start) : '';
        const normalizedSchedule = this.normalizeDraggedSchedule(start, end, this.baseState.operationHours || 24, false);

        // Combine state reset and modal show in one setState call to ensure modal shows
        this.setState({
            ...this.baseState,
            list: this.state.list,
            jobnolist: this.state.jobnolist,
            toolings: this.state.toolings,
            modalShow: true,
            newMode: true,
            schedulerData,
            slotId,
            slotName,
            start: normalizedSchedule.start,
            end: normalizedSchedule.end,
            type,
            item,
            jobNo: autoJobNo,
            masterJobNo: '',
            includeMasterJobNo: false,
            hasExplicitStartTime: false
        });

    }

    updateEventStart = (schedulerData, event, newStart) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to adjust the start of the event? {eventId: ${eventId}, eventTitle: ${event.title}, newStart: ${newStart}}`)) {
            apiFetch(`${config.apiUrl}/updatePlanning`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    start: newStart,
                    id: eventId
                })
            })
                .then((response) => {
                    return response.json().then(data => {
                        if (response.status === 200 && !data.error) {
                            this.loadData();
                            window.alert('Update Successfully.');
                            this.setState({ modalShow: false });
                        } else {
                            window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                        }
                    });
                })
                .catch(error => {
                    console.error('Error updating planning:', error);
                    window.alert('Error updating planning: ' + error.message);
                });
        }
        this.setState({
            viewModel: schedulerData
        })
    }

    updateEventEnd = (schedulerData, event, newEnd) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to adjust the end of the event? {eventId: ${eventId}, eventTitle: ${event.title}, newEnd: ${newEnd}}`)) {
            schedulerData.updateEventEnd(event, newEnd);
        }
        apiFetch(`${config.apiUrl}/updatePlanning`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            //make sure to serialize your JSON body
            body: JSON.stringify({
                end: newEnd,
                id: eventId
            })
        })
            .then((response) => {
                return response.json().then(data => {
                    if (response.status === 200 && !data.error) {
                        this.loadData();
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                    } else {
                        window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                    }
                });
            })
            .catch(error => {
                console.error('Error updating planning:', error);
                window.alert('Error updating planning: ' + error.message);
            });
        this.setState({
            viewModel: schedulerData
        })
    }

    movingEvent = (schedulerData, event, slotId, slotName, newStart, newEnd) => {

    }

    moveEvent = (schedulerData, event, slotId, slotName, start, end) => {
        const eventId = event.oldId || event.id;
        if (!eventId) {
            window.alert('Error: Event ID is missing. Cannot update planning.');
            return;
        }

        if (confirm(`Do you want to move the event? {eventId: ${eventId}, eventTitle: ${event.title}, newSlotId: ${slotId}, newSlotName: ${slotName}, newStart: ${start}, newEnd: ${end}`)) {
            const normalizedSchedule = this.normalizeDraggedSchedule(start, end, event.operationHours || 24, event.ot === true, event.otSaturday === true);
            start = normalizedSchedule.start;
            end = normalizedSchedule.end;
            schedulerData.moveEvent(event, slotId, slotName, start, end);
            apiFetch(`${config.apiUrl}/updatePlanning`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                //make sure to serialize your JSON body
                body: JSON.stringify({
                    start,
                    end,
                    id: eventId
                })
            })
                .then((response) => {
                    return response.json().then(data => {
                        if (response.status === 200 && !data.error) {
                            this.loadData();
                            window.alert('Update Successfully.');
                            this.setState({ modalShow: false });
                        } else {
                            window.alert('Error updating planning: ' + (data.error || 'Unknown error'));
                        }
                    });
                })
                .catch(error => {
                    console.error('Error updating planning:', error);
                    window.alert('Error updating planning: ' + error.message);
                });
            this.setState({
                viewModel: schedulerData
            })
        }
    }

    removeEvent = (event) => {
        this.removePlanningEvent(event);
    }

    getCustomDate = (schedulerData, num, date = undefined) => {
        const { viewType } = schedulerData;
        let selectDate = schedulerData.startDate;

        if (date != undefined)
            selectDate = date;
        // startDate = moment().format('YYYY-MM-DD');

        let startDate = num === 0 ? selectDate :
            moment(selectDate).add(1 * num, 'days').format(DATE_FORMAT),
            endDate = moment(startDate).add(1, 'days').format(DATE_FORMAT),
            cellUnit = CellUnit.Hour;
        let monday = moment(selectDate).startOf('week').format(DATE_FORMAT);
        startDate = moment(startDate).format(DATE_FORMAT);
        endDate = moment(startDate).add(2, 'weeks').format(DATE_FORMAT);
        cellUnit = CellUnit.Day;

        return {
            startDate,
            endDate,
            cellUnit
        };
    }

    isNonWorkingTime = (schedulerData, time) => {
        // SchedulerData may call this during construction, before this.state exists.
        const opHrs = (this.state && this.state.operationHours) || 24;
        if (schedulerData.cellUnit === CellUnit.Hour) {
            return !isPlanningWorkingMoment(moment(time), opHrs);
        }

        // Day columns use start-of-day; fade entire Saturday and Sunday columns.
        const dayOfWeek = moment(time).day();
        return dayOfWeek === 0 || dayOfWeek === 6;
    }

    /** Weekend fade on all rows (including Manpower), which overrides groupOnlySlotColor. */
    getPlanningWeekendCellBgColor = (schedulerData, slotId, header) => {
        if (header.nonWorkingTime) {
            return schedulerData.config.nonWorkingTimeBodyBgColor;
        }
        return undefined;
    }

    toggleExpandFunc = (schedulerData, slotId) => {
        schedulerData.toggleExpandStatus(slotId);
        this.setState({
            viewModel: schedulerData
        });
    }

    eventItemTemplateResolver = (
        schedulerData,
        event,
        bgColor,
        isStart,
        isEnd,
        mustAddCssClass,
        mustBeHeight,
        agendaMaxEventWidth
    ) => {
        const titleText = schedulerData.behaviors.getEventTextFunc(schedulerData, event);

        // Check if this is a Manpower row event (resourceId '2')
        const isManpowerEvent = event.resourceId === '2';

        const style = {
            backgroundColor: isManpowerEvent ? 'transparent' : bgColor,
            height: mustBeHeight,
            borderRadius: isManpowerEvent ? 0 : 14,
            cursor: isManpowerEvent ? 'default' : 'pointer',
            position: 'relative',
            userSelect: 'none',
            color: isManpowerEvent ? '#000000' : undefined
        };

        return (
            <div
                key={event.id}
                className={mustAddCssClass}
                style={style}
                title={titleText}
                onMouseUp={(e) => {
                    // Don't handle clicks for manpower events
                    if (isManpowerEvent) return;

                    setTimeout(() => {
                        if (e.button !== 0) return;

                        // Prevent click-after-drag
                        if (schedulerData._isDragging) return;

                        this.eventClicked(schedulerData, event);
                    }, 0);
                }}
            >
                <span style={{
                    marginLeft: 10,
                    lineHeight: `${mustBeHeight}px`,
                    pointerEvents: 'none',
                    fontWeight: isManpowerEvent ? 'bold' : undefined
                }}>
                    {titleText}
                </span>

                {!isManpowerEvent && (
                    <div
                        title="Delete"
                        style={{
                            position: 'absolute',
                            right: 5,
                            top: 2,
                            cursor: 'pointer'
                        }}
                        onMouseUp={(e) => {
                            e.stopPropagation();
                            this.removeEvent(event);
                        }}
                    >
                        ×
                    </div>
                )}
            </div>
        );
    };

}

export { Planning };
export default Planning;
